import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner, Table } from "react-bootstrap";
import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";
import { intervalToDuration } from "date-fns";

import { injected, walletconnect } from "../components/connectors";
import BuyGeosModal from "../components/buyGeosModal";
import DetailsModal from "../components/detailsModal";
import DownloadsModal from "../components/downloadsModal";
import Footer from "../components/footer";
import Header from "../components/header";
import InfoGeoTokenModal from "../components/infoGeoTokenModal";
import InfoLPModal from "../components/infoLPModal";
import Layout from "../components/layout";
import StakingModal from "../components/stakingModal";

import { sendConnectWalletEvent, sendStakeEvent } from "../services/gtm";

import BiggyImage from "../assets/kid.png";
import token from "../assets/token.png";
import {
  FaChartLine,
  FaDatabase,
  FaInfoCircle,
  // FaSortDown,
} from "react-icons/fa";
import BigNumber from "bignumber.js";
import {
  FARMING_contract,
  GEOS_contract,
  LP_contract,
  STAKING_contract,
} from "../Constants.js";

import { toFormattedGeoTokensAmount } from "../utils/amount";

import "./styles.css";

const { REACT_APP_POLYGONSCAN_API_KEY_TOKEN } = process.env;

const GAS_FEE = "800";

const POLYGON_API_URL = `https://api.polygonscan.com/api?module=gastracker&action=gasoracle&apikey=${REACT_APP_POLYGONSCAN_API_KEY_TOKEN}`;

const MILLISECONDS_TO_SECONDS = 1000;
const MILLISECONDS_IN_YEAR = 31557600000;
const PERCENTAGE_TO_DECIMAL = 100;

const POOL_APYS = {
  geos: {
    48: 1314871 * MILLISECONDS_TO_SECONDS, //15 days,
    60: 2629743 * MILLISECONDS_TO_SECONDS, //30 days,
  },
  lp: {
    120: 1314871 * MILLISECONDS_TO_SECONDS, //15 days,
    180: 2629743 * MILLISECONDS_TO_SECONDS, //30 days,
  },
};

const Staking = () => {
  const { active, account, library, activate, deactivate } = useWeb3React();

  const [stage, setStage] = useState(0);
  const [popup, setPopup] = useState({
    typ: null,
    stat: false,
  });
  const [totalStaked, setTotalStaked] = useState("1M");
  // const [tab, setTab] = useState("Locked");
  const [stakingFee, setStakingFee] = useState("0.1");
  const [stakingType, setStakingType] = useState("geos");
  const [isApproved, setIsApproved] = useState(false);
  // contract hooks

  // const [statstics, setStatistics] = useState({
  //   total_distrbuted: "12M",
  //   geos_val: "44.8M",
  // }); // for stage 0

  const [pool, setPools] = useState({
    geos: {
      tvl: "264,632.5",
      apy: "60",
    },
    lp: {
      tvl: "1,264,632.5",
      apy: "180",
    },
  }); // for stage 2 table

  const [details, setDetails] = useState({
    geos: {
      tvl: null,
      weight: 27,
      pen_rew: null,
      apy: null,
      liq: null,
    },
    lp: {
      tvl: null,
      weight: 72,
      pen_rew: null,
      apy: null,
      liq: null,
    },
  });

  const [amount, setAmount] = useState("");

  const [balance, setBalance] = useState({
    geos: 1000,
    lp: 0.001,
  });
  const [geosPrice, setGeosPrice] = useState("0.043");
  const [didUpdateProps, setDidUpdateProps] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [lockTime, setLockTime] = useState(2);

  const [geoTokensAmount, setGeoTokensAmount] = useState("-");
  const [NFTsAmount, setNFTsAmount] = useState("-");
  // const [geoSpinsAmount, setGeoSpinsAmount] = useState("-");
  const [displayBuyGEOTokens, setDisplayBuyGEOTokens] = useState(false);
  const [displayDownloads, setDisplayDownloads] = useState(false);

  const getGasFee = async () => {
    try {
      const response = await fetch(POLYGON_API_URL);
      const { result } = await response.json();
      const { FastGasPrice } = result;

      return FastGasPrice;
    } catch (err) {
      console.log(err);
      return GAS_FEE;
    }
  };

  const getFormattedDiff = (start, end) => {
    const diff = intervalToDuration({
      start,
      end,
    });
    return `${diff.days}d ${diff.hours}h ${diff.minutes}m`;
  };

  const getProps = () => {
    getCurrentParticipation();
    // getGeosBalance();
    getStakingFee();
    // getLPBalance();
    getBalances();
    getDetails();
    setDidUpdateProps(true);
    setIsLoading(false);
  };

  useEffect(() => {
    initHeaderData();
    getCurrentGeosPrice();
    getTotalStaked();
    if (active && !didUpdateProps) {
      getProps();
    }
  });

  useEffect(() => {
    if (active) {
      sendConnectWalletEvent("Confirmation");
    }
  }, [active]);

  function setNewGEOSprice(reserves) {
    var geos_liq = new BigNumber(reserves["_reserve1"]);
    var usdt_liq = new BigNumber(reserves["_reserve0"]);
    var geos_price = usdt_liq.div(1e6).div(geos_liq.div(1e18)).toFixed(4);
    setGeosPrice(geos_price);
  }

  async function getCurrentGeosPrice() {
    var w3 = new Web3("https://polygon-rpc.com");
    var contract = new w3.eth.Contract(LP_contract.abi, LP_contract.address);
    await contract.methods
      .getReserves()
      .call()
      .then((res) => setNewGEOSprice(res))
      .catch((err) => console.log(err));
  }

  async function getTotalStaked() {
    var w3 = new Web3("https://polygon-rpc.com");
    var contract = new w3.eth.Contract(
      STAKING_contract.abi,
      STAKING_contract.address
    );

    let _total = new BigNumber(0);
    try {
      const res = await contract.methods
        .getCurrentStaked(LP_contract.address)
        .call();
      if (res) {
        _total = _total.plus(new BigNumber(res));
      }
    } catch (err) {
      console.log(err);
    }

    try {
      const res = await contract.methods
        .getCurrentStaked(GEOS_contract.address)
        .call();
      if (res) {
        _total = _total.plus(new BigNumber(res));
      }
    } catch (err) {
      console.log(err);
    }

    setTotalStaked(Web3.utils.fromWei(Web3.utils.toBN(_total)), "ether");
    setIsLoading(false);
  }

  // web3 calls
  function getContract(contract_name, web3_instance = null) {
    try {
      switch (contract_name.toLowerCase()) {
        case "geos":
          return new library.eth.Contract(
            GEOS_contract.abi,
            GEOS_contract.address
          );
        case "lp":
          return new library.eth.Contract(LP_contract.abi, LP_contract.address);
        case "staking":
          return new library.eth.Contract(
            STAKING_contract.abi,
            STAKING_contract.address
          );
        default:
          return null;
      }
    } catch {
      console.log("cannot retrieve contract");
    }
  }

  function getWeb3Obj(obj_name) {
    switch (obj_name.toLowerCase()) {
      case "geos":
        return GEOS_contract;
      case "lp":
        return LP_contract;
      case "staking":
        return STAKING_contract;
      default:
        return null;
    }
  }

  function formPoolProps(_props) {
    setPools({
      lp: {
        tvl:
          _props["lp"]["currentParticipation"] != "0"
            ? Web3.utils.fromWei(_props["lp"]["currentParticipation"], "ether")
            : "0",
        minStake: _props["lp"]["minAllowed"],
        apy: "180",
      },
      geos: {
        tvl:
          _props["geos"]["currentParticipation"] != "0"
            ? Web3.utils.fromWei(
                _props["geos"]["currentParticipation"],
                "ether"
              )
            : "0",
        minStake: _props["geos"]["minAllowed"],
        apy: "60",
      },
    });
  }

  function getAvgFromArr(_arr, inW) {
    if (_arr.length === 0) {
      return 0;
    }

    if (inW) {
      var total = new BigNumber("0");
      for (var i = 0; i < _arr.length; i++) {
        total = total.plus(new BigNumber(_arr[i]));
      }
      console.log("total is=", total);
      return total;
    } else {
      var total = 0;
      for (var i = 0; i < _arr.length; i++) {
        total += _arr[i];
      }
      return total / _arr.length;
    }
  }

  function getAvgFromArrString(_arr, inW) {
    if (_arr.length === 0) {
      return "0";
    }

    const total = getAvgFromArr(_arr, inW);
    return inW
      ? Web3.utils.fromWei(Web3.utils.toBN(total), "ether")
      : total.toFixed(3).toString();
  }

  const getTotalClaimableTokens = async (
    amountsStaked,
    rois,
    isLP,
    contractAddress
  ) => {
    const staking_contract = getContract("staking");
    const promises = amountsStaked.reduce(
      (claimableTokens, amount, index) => [
        ...claimableTokens,
        staking_contract.methods
          ._calcReturn(
            amount,
            rois[index],
            isLP,
            Web3.utils.toChecksumAddress(contractAddress)
          )
          .call(),
      ],
      []
    );
    const data = await Promise.all(promises);
    const totalClaimableTokens = data.reduce(
      (sum, amount) => sum.plus(new BigNumber(amount)),
      new BigNumber("0")
    );
    return Web3.utils.fromWei(Web3.utils.toBN(totalClaimableTokens), "ether");
  };

  const getAmountOfMillisecondsFromRoi = (pool, roi) => POOL_APYS[pool][roi];

  const getCalculatedPercentage = (pool, roi, unlockTime, now) => {
    const lockTimeInMilliseconds = getAmountOfMillisecondsFromRoi(pool, roi);
    const initialTime = new Date(
      new Date(unlockTime) - new Date(lockTimeInMilliseconds)
    );
    const millisecondsUntilNow = now.getTime() - initialTime.getTime();
    const offset = MILLISECONDS_IN_YEAR / millisecondsUntilNow;

    return roi / (offset * PERCENTAGE_TO_DECIMAL);
  };

  const getTotalTokensRewardedUpToDate = async ({
    amountsStaked,
    rois,
    unlockTimes,
    isLP,
    contractAddress,
  }) => {
    const now = new Date();
    let totalTokensRewardedUpToDate = new BigNumber("0");

    for await (const [index, amount] of amountsStaked.entries()) {
      const unlockTime = new Date(unlockTimes[index] * MILLISECONDS_TO_SECONDS);
      if (unlockTime < now) {
        continue;
      }

      let finalAmount;
      const calculatedPercentage = getCalculatedPercentage(
        isLP ? "lp" : "geos",
        rois[index],
        unlockTime,
        now
      );

      if (isLP) {
        try {
          const stakingContract = getContract("staking");
          const geosFromLP = await stakingContract.methods
            ._getInGEOSFromLP(contractAddress, amount)
            .call();
          finalAmount = new BigNumber(geosFromLP).multipliedBy(
            calculatedPercentage
          );
        } catch (err) {
          console.log(err);
          continue;
        }
      } else {
        const amountBN = new BigNumber(amount);
        finalAmount = amountBN.plus(
          amountBN.multipliedBy(calculatedPercentage)
        );
      }

      totalTokensRewardedUpToDate =
        totalTokensRewardedUpToDate.plus(finalAmount);
    }

    return Web3.utils.fromWei(totalTokensRewardedUpToDate.toFixed(0), "ether");
  };

  function truncate(str, n) {
    return str.length > n ? str.substr(0, n - 1) : str;
  }
  async function getStakingFee() {
    var contract = getContract("staking");
    await contract.methods
      .stakingFee()
      .call()
      .then((res) => {
        setStakingFee(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // async function getGeosBalance(){
  //     await contract.methods.balanceOf(Web3.utils.toChecksumAddress(account)).call()
  //         .then((res) => {
  //             _bal['geos'] = truncate(Web3.utils.fromWei(res, 'ether'), 10);
  //         }).catch((err) => {console.log(err);});

  //     setBalance(_bal);
  // }
  // async function getLPBalance(){
  //     var contract = getContract('lp');
  //     var _bal = {geos:balance.geos};
  //     await contract.methods.balanceOf(Web3.utils.toChecksumAddress(account)).call()
  //         .then((res) => {
  //             _bal['lp'] = truncate(Web3.utils.fromWei(res, 'ether'), 10)
  //         }).catch((err) => {console.log(err);});
  //     setBalance(_bal);
  // }
  async function getBalances() {
    var _bal = {};
    var g_contract = getContract("geos");
    var l_contract = getContract("lp");
    await g_contract.methods
      .balanceOf(Web3.utils.toChecksumAddress(account))
      .call()
      .then((res) => {
        _bal["geos"] = truncate(Web3.utils.fromWei(res, "ether"), 10);
      })
      .catch((err) => {
        console.log(err);
      });
    await l_contract.methods
      .balanceOf(Web3.utils.toChecksumAddress(account))
      .call()
      .then((res) => {
        _bal["lp"] = truncate(Web3.utils.fromWei(res, "ether"), 10);
      })
      .catch((err) => {
        console.log(err);
      });
    setBalance(_bal);
  }
  async function getCurrentParticipation() {
    var contract = getContract("staking");
    var _participation = {};
    await contract.methods
      .getPoolProps(GEOS_contract.address)
      .call()
      .then((res) => {
        if (res) {
          _participation["geos"] = res;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    await contract.methods
      .getPoolProps(LP_contract.address)
      .call()
      .then((res2) => {
        if (res2) {
          _participation["lp"] = res2;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    formPoolProps(_participation);
  }
  async function approveTokens(amnt) {
    if (typeof amnt === "undefined" || amnt === "") {
      alert("cannot stake 0 tokens!");
      return;
    }
    setIsLoading(true);
    setAmount(amnt);
    var contract = getContract(stakingType);

    const gasFee = await getGasFee();

    await contract.methods
      .approve(
        Web3.utils.toChecksumAddress(STAKING_contract.address),
        Web3.utils.toWei(amnt.toString(), "ether")
      )
      .send({
        from: Web3.utils.toChecksumAddress(account),
        to: Web3.utils.toChecksumAddress(contract.address),
        gasPrice: Web3.utils.toWei(gasFee, "gwei"),
        // maxPriorityFeePerGas: null,
        // maxFeePerGas: null,
      })
      .then((res) => {
        if (res) {
          setIsLoading(false);
          setIsApproved(true);
          return true;
        } else {
          setIsLoading(false);
          alert("failed to approve tokens for staking");
          return false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const geoStake = async (amnt, lockTime) => {
    if (typeof amnt === "undefined" || amnt === "") {
      if (amount !== "") {
        amnt = amount;
      } else {
        alert("cannot stake 0 tokens!");
        return;
      }
    }
    setIsLoading(true);
    var contract = getWeb3Obj(stakingType);
    var staking_contract = getContract("staking");

    const gasFee = await getGasFee();

    await staking_contract.methods
      .GeoStake(
        Web3.utils.toChecksumAddress(contract.address),
        lockTime == 2 ? "0" : "1",
        Web3.utils.toWei(amnt.toString(), "ether")
      )
      .send({
        from: Web3.utils.toChecksumAddress(account),
        to: Web3.utils.toChecksumAddress(STAKING_contract.address),
        value: stakingFee,
        gasPrice: Web3.utils.toWei(gasFee, "gwei"),
        // maxPriorityFeePerGas: null,
        // maxFeePerGas: null,
      })
      .then((res) => {
        if (res) {
          setIsLoading(false);
          setDidUpdateProps(false);

          sendStakeEvent(stakingType === "geos" ? "GEO" : "GEO/USDT");
          alert("staked sucessfully!");
        } else {
          setIsLoading(false);
          alert("unable to stake");
        }
      })
      .catch((err) => {
        console.log(err);
        alert("unable to stake");
      });
    setIsLoading(false);
    setTimeout(() => {
      getProps();
    }, 1000);
  };
  async function GeoReturn() {
    setIsLoading(true);
    var contract = getWeb3Obj(stakingType);
    var staking_contract = getContract("staking");

    const gasFee = await getGasFee();

    await staking_contract.methods
      .GeoReturn(Web3.utils.toChecksumAddress(contract.address))
      .send({
        from: Web3.utils.toChecksumAddress(account),
        to: Web3.utils.toChecksumAddress(STAKING_contract.address),
        gasPrice: Web3.utils.toWei(gasFee, "gwei"),
        // maxPriorityFeePerGas: null,
        // maxFeePerGas: null,
      })
      .then((res) => {
        if (res) {
          setIsLoading(false);
          alert("claimed stakes sucessfully!");
          getProps();
        } else {
          setIsLoading(false);
          alert("cannot claim stakes!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setIsLoading(false);
    getProps();
  }

  async function getDetails() {
    var staking_contract = getContract("staking");
    var _details = details;
    _details["geos"]["weight"] = 27;
    _details["lp"]["weight"] = 72;

    const now = new Date();

    await staking_contract.methods
      .totalReturnable(account, GEOS_contract.address)
      .call()
      .then((res) => {
        if (res) {
          _details["geos"]["pen_rew"] = Web3.utils.fromWei(
            res["total"],
            "ether"
          );
        }
      })
      .catch((err) => console.log(err));
    await staking_contract.methods
      .totalReturnable(account, LP_contract.address)
      .call()
      .then((res) => {
        if (res) {
          _details["lp"]["pen_rew"] = Web3.utils.fromWei(res["total"], "ether");
        }
      })
      .catch((err) => console.log(err));
    await staking_contract.methods
      .getStakes(
        Web3.utils.toChecksumAddress(account),
        Web3.utils.toChecksumAddress(GEOS_contract.address)
      )
      .call()
      .then(async (res) => {
        if (res) {
          _details["geos"]["tvl"] = getAvgFromArrString(
            res["amountStaked"],
            true
          );
          _details["geos"]["apy"] = getAvgFromArrString(res["roi"], false);

          _details["geos"]["timesToNextClaim"] = res["unlockTimes"]
            .map((unlockTime) => {
              const unlockTimeDate = new Date(
                unlockTime * MILLISECONDS_TO_SECONDS
              );
              if (unlockTimeDate < now) {
                return undefined;
              }
              return getFormattedDiff(now, unlockTimeDate);
            })
            .filter((unlockTime) => unlockTime);

          try {
            _details["geos"]["totalClaimableTokens"] =
              await getTotalClaimableTokens(
                res["amountStaked"],
                res["roi"],
                false,
                GEOS_contract.address
              );
          } catch (err) {
            console.log(err);
          }

          try {
            _details["geos"]["totalTokensRewardedUpToDate"] =
              await getTotalTokensRewardedUpToDate({
                amountsStaked: res["amountStaked"],
                rois: res["roi"],
                unlockTimes: res["unlockTimes"],
                isLP: false,
              });
          } catch (err) {
            console.log(err);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    await staking_contract.methods
      .getStakes(
        Web3.utils.toChecksumAddress(account),
        Web3.utils.toChecksumAddress(LP_contract.address)
      )
      .call()
      .then(async (res) => {
        if (res) {
          _details["lp"]["tvl"] = getAvgFromArrString(
            res["amountStaked"],
            true
          );
          _details["lp"]["apy"] = getAvgFromArrString(res["roi"], false);

          _details["lp"]["timesToNextClaim"] = res["unlockTimes"]
            .map((unlockTime) => {
              const unlockTimeDate = new Date(
                unlockTime * MILLISECONDS_TO_SECONDS
              );
              if (unlockTimeDate < now) {
                return undefined;
              }
              return getFormattedDiff(now, unlockTimeDate);
            })
            .filter((unlockTime) => unlockTime);

          try {
            _details["lp"]["totalClaimableTokens"] =
              await getTotalClaimableTokens(
                res["amountStaked"],
                res["roi"],
                true,
                LP_contract.address
              );
          } catch (err) {
            console.log(err);
          }

          try {
            _details["lp"]["totalTokensRewardedUpToDate"] =
              await getTotalTokensRewardedUpToDate({
                amountsStaked: res["amountStaked"],
                rois: res["roi"],
                unlockTimes: res["unlockTimes"],
                isLP: true,
                contractAddress: LP_contract.address,
              });
          } catch (err) {
            console.log(err);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });

    setDetails(_details);
  }

  // Wallet Connection
  async function connectInjected() {
    try {
      sendConnectWalletEvent("Intention");
      await activate(injected);
      setStage(2);
      setIsLoading(true);
    } catch (err) {
      console.log(err);
    }
  }
  async function disconnect() {
    try {
      deactivate();
    } catch (ex) {
      console.log(ex);
    }
  }

  function connectMapper(conn_type) {
    if (!active) {
      switch (conn_type) {
        case "MetaMask":
          return connectInjected();
        case "Wallet Connect":
          return connectWalletConnect();
        case "Trust Wallet":
          return connectInjected();
      }
    }
  }

  const connectedWalletAddress = () => {
    if (active) {
      const address = account.split("");
      var _wallet =
        address[0] +
        address[1] +
        address[2] +
        address[3] +
        address[4] +
        address[5] +
        "..." +
        address[38] +
        address[39] +
        address[40] +
        address[41];
      return _wallet;
    }
  };
  async function connectWalletConnect() {
    try {
      sendConnectWalletEvent("Intention");
      await activate(walletconnect);
    } catch (ex) {
      console.log(ex);
    }
  }

  const initHeaderData = () => {
    if (active) {
      getGeoTokensAmount();
      getNFTsAmount();
      // getGeoSpinsAmount();
    }
  };

  const getGeoTokensAmount = async () => {
    const contract = new library.eth.Contract(
      GEOS_contract.abi,
      GEOS_contract.address
    );

    try {
      await contract.methods
        .balanceOf(Web3.utils.toChecksumAddress(account))
        .call()
        .then((res) => {
          const amount = Web3.utils.fromWei(res, "ether");
          setGeoTokensAmount(toFormattedGeoTokensAmount(amount));
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const getNFTsAmount = async () => {
    const contract = new library.eth.Contract(
      FARMING_contract.abi,
      FARMING_contract.address
    );

    try {
      const NFTs = await contract.methods
        .getWalletNFTs(library.utils.toChecksumAddress(account))
        .call();
      setNFTsAmount(NFTs.length);
    } catch (err) {
      console.log(err);
    }
  };

  // const getGeoSpinsAmount = async () => {
  //   const contract = new library.eth.Contract(
  //     FARMING_contract.abi,
  //     FARMING_contract.address
  //   );

  //   try {
  //     const amount = await contract.methods
  //       .spinBalance(library.utils.toChecksumAddress(account))
  //       .call();
  //     setGeoSpinsAmount(amount);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const Stages = () => {
    switch (stage) {
      case 0:
        return (
          <Container className="stage-0">
            <Row>
              <Col xs={12} md={6}>
                <Container className="card-core-pools">
                  <Row>
                    <Col xs={12}>
                      <Row className="justify-content-center">
                        <FaDatabase size={32} className="database-icon" />
                      </Row>
                      <Row className="justify-content-center">
                        <h2>Staking</h2>
                      </Row>
                      <Row className="text-center">
                        <p>
                          Here you are able to benefit from staking tokens and
                          receiving GEO$ rewards
                        </p>
                      </Row>
                      <Row className="justify-content-center">
                        <button className="purple" onClick={() => setStage(1)}>
                          CORE POOLS
                        </button>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </Col>
              <Col xs={12} md={6}>
                <Container className="card-chart">
                  <Row>
                    <Col xs={12}>
                      <Row className="justify-content-center">
                        <FaChartLine size={64} className="chart-icon" />
                      </Row>
                      <Row className="align-items-center justify-content-center mb-3">
                        <span className="geo-text mr-1">GEO$ </span>
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <span className="geo-price">${geosPrice}</span>
                        )}
                        {/* <FaSortDown size={20} className="red ml-2" />
                        <span className="geo-amount">-0.57</span> */}
                      </Row>
                      <Row className="justify-content-center mb-1">
                        <span>Total Amount Staked:</span>
                      </Row>
                      <Row className="justify-content-center mb-3">
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <span className="bold">${totalStaked}</span>
                        )}
                      </Row>
                      <Row className="justify-content-center mb-1">
                        <span>Amount Claimed:</span>
                      </Row>
                      <Row className="justify-content-center">
                        <span className="bold">TBD</span>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>
        );
      case 1:
        return (
          <Container className="stage-1">
            <Row className="align-items-center mx-auto">
              <Col xs={12} sm={5} className="text-center">
                <img
                  className="connect-wallet-biggy"
                  src={BiggyImage}
                  alt="Biggy"
                />
              </Col>
              <Col xs={12} sm={7} className="core-pools-col text-center mt-4">
                <Row className="card-core-pools justify-content-center p-3 mb-4">
                  <h1 className="core-pools-text">Core Pools</h1>
                  <p className="core-pools-description">
                    there are two pools in the GeoPoly protocol. GEO$ and
                    GEO$/USDT both offer variable locking for up to 30 days
                  </p>
                </Row>
                <Row className="justify-content-center">
                  <p className="connect-wallet-text">
                    Please Connect your wallet to see available core pools
                  </p>
                </Row>
                <Row className="justify-content-center">
                  <button
                    className="connect-wallet-button mx-auto"
                    onClick={() => connectMapper("MetaMask")}
                  >
                    Connect Wallet
                  </button>
                </Row>
              </Col>
            </Row>
          </Container>
        );
      case 2:
        return (
          <Container className="stage-2">
            <Row className="align-items-center mx-auto">
              <Col xs={12} className="core-pools-col text-center">
                <Row className="card-core-pools justify-content-center p-3">
                  <h1 className="core-pools-text">Core Pools</h1>
                  <p className="core-pools-description">
                    there are two pools in the GeoPoly protocol. GEO$ and
                    GEO$/USDT both offer variable locking for up to 30 days
                  </p>
                </Row>
                <Row className="d-none d-md-flex">
                  <Table className="table-core-pools">
                    <thead className="table-core-pools-head">
                      <tr>
                        <th>Pool</th>
                        <th>TVL</th>
                        <th>APY</th>
                        <th>My Staking</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody className="table-core-pools-body align-items-center">
                      <tr>
                        <td className="align-middle text-center">
                          <img src={token} alt="token" className="mr-2" />
                          GEO$ Token
                          <i
                            onClick={() => {
                              setStakingType("geos");
                              setPopup({ typ: "GEOS", stat: true });
                            }}
                          >
                            <FaInfoCircle
                              size={18}
                              className="info-icon ml-2"
                            />
                          </i>
                        </td>
                        <td className="align-middle text-center">
                          {isLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            `$ ${parseFloat(
                              parseFloat(pool.geos.tvl) * parseFloat(geosPrice)
                            )
                              .toFixed(4)
                              .toString()}`
                          )}
                        </td>
                        <td className="align-middle text-center">
                          {isLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            `${pool.geos.apy}%`
                          )}
                        </td>
                        <td className="align-middle text-center">
                          <button
                            onClick={() => {
                              setStakingType("geos");
                              setPopup({ typ: "DETAILS", stat: true });
                            }}
                            className="details"
                          >
                            Details
                          </button>
                        </td>
                        <td className="align-middle text-center">
                          <button
                            onClick={() => {
                              setStakingType("geos");
                              setPopup({ typ: "STAKE", stat: true });
                            }}
                            className="stake"
                          >
                            Stake
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="align-middle text-center">
                          <img src={token} alt="token" className="mr-2" />
                          GEO$/USDT
                          <i
                            onClick={() => {
                              setStakingType("lp");
                              setPopup({ typ: "LP", stat: true });
                            }}
                          >
                            <FaInfoCircle
                              size={18}
                              className="info-icon ml-2"
                            />
                          </i>
                        </td>
                        <td className="align-middle text-center">
                          {isLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            `$ ${parseFloat(
                              (parseFloat(pool.lp.tvl) * 300000) / 1.421
                            )
                              .toFixed(4)
                              .toString()}`
                          )}
                        </td>
                        <td className="align-middle text-center">
                          {isLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            `${pool.lp.apy}%`
                          )}
                        </td>
                        <td className="align-middle text-center">
                          <button
                            onClick={() => {
                              setStakingType("lp");
                              setPopup({ typ: "DETAILS", stat: true });
                            }}
                            className="details"
                          >
                            Details
                          </button>
                        </td>
                        <td className="align-middle text-center">
                          <button
                            onClick={() => {
                              setStakingType("lp");
                              setPopup({ typ: "STAKE", stat: true });
                            }}
                            className="stake"
                          >
                            Stake
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Row>
                <Row className="d-flex d-md-none">
                  <Container className="geo-token-container p-3 mb-3">
                    <Row className="geo-token-row-title pl-3 pb-3">
                      <img src={token} alt="token" className="mr-2" />
                      GEO$ Token
                      <i
                        onClick={() => {
                          setStakingType("geos");
                          setPopup({ typ: "GEOS", stat: true });
                        }}
                      >
                        <FaInfoCircle size={18} className="info-icon ml-2" />
                      </i>
                    </Row>
                    <Row className="pt-2 pb-2">
                      <Col xs={6}>
                        <span className="head">TVL</span>
                      </Col>
                      <Col>
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <span>
                            {`$
                            ${parseFloat(
                              parseFloat(pool.geos.tvl) * parseFloat(geosPrice)
                            )
                              .toFixed(4)
                              .toString()}
                            `}
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row className="pt-2 pb-2">
                      <Col xs={6}>
                        <span className="head">APY</span>
                      </Col>
                      <Col>
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <span>{`${pool.geos.apy}%`}</span>
                        )}
                      </Col>
                    </Row>
                    <Row className="geo-token-row-buttons pt-3 pl-2 pr-2">
                      <Col xs={6}>
                        <button
                          onClick={() => {
                            setStakingType("geos");
                            setPopup({ typ: "DETAILS", stat: true });
                          }}
                          className="details"
                        >
                          Details
                        </button>
                      </Col>
                      <Col>
                        <button
                          onClick={() => {
                            setStakingType("geos");
                            setPopup({ typ: "STAKE", stat: true });
                          }}
                          className="stake"
                        >
                          Stake
                        </button>
                      </Col>
                    </Row>
                  </Container>
                  <Container className="geo-token-container p-3">
                    <Row className="geo-token-row-title pl-3 pb-3">
                      <img src={token} alt="token" className="mr-2" />
                      GEO$/USDT
                      <i
                        onClick={() => {
                          setStakingType("lp");
                          setPopup({ typ: "LP", stat: true });
                        }}
                      >
                        <FaInfoCircle size={18} className="info-icon ml-2" />
                      </i>
                    </Row>
                    <Row className="pt-2 pb-2">
                      <Col xs={6}>
                        <span className="head">TVL</span>
                      </Col>
                      <Col>
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <span>
                            {`$
                            ${parseFloat(
                              (parseFloat(pool.lp.tvl) * 300000) / 1.421
                            )
                              .toFixed(4)
                              .toString()}
                            `}
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row className="pt-2 pb-2">
                      <Col xs={6}>
                        <span className="head">APY</span>
                      </Col>
                      <Col>
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <span>{`${pool.lp.apy}%`}</span>
                        )}
                      </Col>
                    </Row>
                    <Row className="geo-token-row-buttons pt-3 pl-2 pr-2">
                      <Col xs={6}>
                        <button
                          onClick={() => {
                            setStakingType("lp");
                            setPopup({ typ: "DETAILS", stat: true });
                          }}
                          className="details"
                        >
                          Details
                        </button>
                      </Col>
                      <Col>
                        <button
                          onClick={() => {
                            setStakingType("lp");
                            setPopup({ typ: "STAKE", stat: true });
                          }}
                          className="stake"
                        >
                          Stake
                        </button>
                      </Col>
                    </Row>
                  </Container>
                </Row>
              </Col>
            </Row>
          </Container>
        );
      default:
        return null;
    }
  };

  function checkVal(_val) {
    if (parseFloat(_val) === 0) {
      return false;
    }
    return true;
  }

  const PopUps = () => (
    <>
      <InfoLPModal
        displayModal={popup.typ === "LP"}
        setDisplayModal={(stat) => setPopup({ stat })}
      />
      <InfoGeoTokenModal
        displayModal={popup.typ === "GEOS"}
        setDisplayModal={(stat) => setPopup({ stat })}
      />
      <DetailsModal
        title="GEO$"
        address={connectedWalletAddress()}
        details={details.geos}
        apy={pool.geos.apy}
        liquidity={`${balance.geos} GEO$`}
        isLoading={isLoading}
        buttonLabel={checkVal(details.geos.pen_rew) ? "Unstake" : "Stake"}
        onPressButton={
          checkVal(details.geos.pen_rew)
            ? () => GeoReturn()
            : () => {
                setStakingType("geos");
                setPopup({ typ: "STAKE", stat: true });
              }
        }
        displayModal={popup.typ === "DETAILS" && stakingType === "geos"}
        setDisplayModal={(stat) => setPopup({ stat })}
      />
      <DetailsModal
        title="GEO$/USDT"
        address={connectedWalletAddress()}
        details={details.lp}
        apy={pool.lp.apy}
        liquidity={`${balance.lp} LP`}
        isLoading={isLoading}
        buttonLabel={checkVal(details.lp.pen_rew) ? "Unstake" : "Stake"}
        onPressButton={
          checkVal(details.lp.pen_rew)
            ? () => GeoReturn()
            : () => {
                setStakingType("lp");
                setPopup({ typ: "STAKE", stat: true });
              }
        }
        displayModal={popup.typ === "DETAILS" && stakingType === "lp"}
        setDisplayModal={(stat) => setPopup({ stat })}
      />
      <StakingModal
        title={stakingType === "geos" ? "GEO$" : "GEO$/USDT"}
        isLoading={isLoading}
        displayModal={popup.typ === "STAKE"}
        setDisplayModal={(stat) => setPopup({ stat })}
        stakingType={stakingType}
        balance={balance}
        amount={amount}
        isApproved={isApproved}
        approveTokens={approveTokens}
        geoStake={geoStake}
        lockTime={lockTime}
        setLockTime={setLockTime}
      />
    </>
  );
  return (
    <>
      <BuyGeosModal
        displayModal={displayBuyGEOTokens}
        setDisplayModal={setDisplayBuyGEOTokens}
      />
      <DownloadsModal
        displayModal={displayDownloads}
        setDisplayModal={setDisplayDownloads}
      />
      <Header
        geoTokensAmount={geoTokensAmount}
        NFTsAmount={NFTsAmount}
        // geoSpinsAmount={geoSpinsAmount}
        setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
        setDisplayDownloads={setDisplayDownloads}
        onClickConnectWallet={() => connectMapper("MetaMask")}
      />
      <PopUps />
      <Layout>
        <Container fluid className="staking">
          <Row className="title">
            <p>
              <span className="purple">Classic</span>
              Staking
            </p>
          </Row>
          <Row className="mb-5">
            <Stages />
          </Row>
        </Container>
      </Layout>
      <Footer />
    </>
  );
};

export default Staking;
